import { ReactNode } from 'react';

import { Typography } from 'antd';

import Tabs from '@/components/shared/Tabs';
import { useAppSelector } from '@/hooks/redux';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { blockedStatus, enStatus } from '@/interfaces/course';

import Comments from './Comments';
import Contact from './Contact';
import Description from './Description';
import Files from './Files';
import Notes from './Notes';
import Timeline from '../Timeline';

const ActionBar = ({
  status,
  disable_comments,
  disable_talk_to_producer
}: {
  status: enStatus;
  disable_comments: boolean;
  disable_talk_to_producer: boolean;
}) => {
  const breakpoints = useBreakpoints();
  const user = useAppSelector(state => state.auth.user);
  const defaultActiveKey = window.location.hash.replace('#', '') || 'descricao';
  const handleBlockedTab = (message: string, element: ReactNode) => {
    if (blockedStatus.includes(status)) {
      return <Typography.Text>{message}</Typography.Text>;
    }

    return element;
  };

  const tabs = [
    { label: 'Descrição', key: 'descricao', children: <Description key='Descrição' /> },
    {
      label: 'Arquivos',
      key: 'arquivos',
      children: handleBlockedTab('Você precisa estar logado para ver os arquivos dessa aula', <Files key='Files' />)
    }
  ];

  if (user) {
    if (!disable_comments) {
      tabs.push({
        label: 'Comentários',
        key: 'comentarios',
        children: handleBlockedTab(
          'Você precisa estar logado para ver os comentários dessa aula',
          <Comments key='Comments' />
        )
      });
    }

    tabs.push({
      label: 'Anotações',
      key: 'anotacoes',
      children: handleBlockedTab('Você precisa estar logado para ver as anotações dessa aula', <Notes key='Notes' />)
    });

    if (!disable_talk_to_producer) {
      tabs.push({
        label: 'Falar com Produtor',
        key: 'falar-com-produtor',
        children: <Contact key='Falar com Produtor' />
      });
    }
  }

  if (breakpoints.down('md')) {
    const mobileTabs = [...tabs, { label: 'Conteúdo', key: 'conteudo', children: <Timeline key='Timeline' /> }];

    return <Tabs items={mobileTabs} />;
  }

  return <Tabs defaultActiveKey={defaultActiveKey.toLocaleLowerCase()} items={tabs} />;
};

export default ActionBar;
